export const TYPE = { SKU: 'sku', LANDING: 'landing' };
